import { Notify } from "@flexisaf/flexibull2";
import { call, put, takeLatest } from "redux-saga/effects";
import { deleteExamGroup } from "../../../services/examGroup";
import {
  deleteGroupStart,
  deleteGroupSuccess,
  deleteGroupFailure,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";

export function* deleteGroup({ payload }) {
  const { id, callback } = payload;

  const response = yield call(deleteExamGroup, id);
  const { success, raw, message, statusCode } = response;

  if (success) {
    yield put(deleteGroupSuccess());
    Notify("Group deleted successfully", { status: "success" });
    if (callback) {
      callback();
    }
  } else {
    yield put(deleteGroupFailure(message || raw.error));
    networkErrorHandler(statusCode, message || raw.error);
  }
}

export default function* onDeleteGroup() {
  yield takeLatest(deleteGroupStart.type, deleteGroup);
}
